// routes
import { SnackbarProvider } from 'notistack';
import { QueryClient, QueryClientProvider } from 'react-query';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import ThemeColorPresets from './components/ThemeColorPresets';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import { HeaderProvider } from './contexts/HeaderContext';

// ----------------------------------------------------------------------
const INITIAL_SETTINGS = {
  themeMode: 'light',
  themeDirection: 'rtl',
  themeColorPresets: 'purple',
  themeLayout: 'horizontal',
  themeStretch: true,
};

export default function App() {
  localStorage.setItem('settings', JSON.stringify(INITIAL_SETTINGS));

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        keepPreviousData: true,
        retry: 1,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ThemeColorPresets>
          <RtlLayout>
            <MotionLazyContainer>
              <SnackbarProvider
                maxSnack={4}
                preventDuplicate
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <ProgressBarStyle />

                {/* <Settings /> */}
                <ScrollToTop />
                <HeaderProvider>
                  <QueryParamProvider adapter={ReactRouter6Adapter}>
                    <Router />
                  </QueryParamProvider>
                </HeaderProvider>
              </SnackbarProvider>
            </MotionLazyContainer>
          </RtlLayout>
        </ThemeColorPresets>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
